import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type
const dependentslistSlice = createSlice({
  name: "dependentslist",

  initialState: { dependentslist: [], dependentListLoader: false },
  reducers: {
    setAlldependentslist: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.dependentslist = payload;
    },
    setAlldependentslistLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.dependentListLoader = payload;
    },
    resetAlldependentslist: (state) => {
      state.dependentslist = [];
    },
  },
});

export const {
  setAlldependentslist,
  resetAlldependentslist,
  setAlldependentslistLoader,
} = dependentslistSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default dependentslistSlice.reducer;
